module.exports = __webpack_public_path__ + "img/1052623023.37c93fd0.jpg";